<!-- components/zone-levels-popover/zone-levels-popover.component.html -->
<dx-popover
    #popover
    [(visible)]="visible"
    [target]="targetElement"
    [showTitle]="true"
    [width]="275"
    [height]="'auto'"
    [maxHeight]="600"
    [showCloseButton]="false"
    [shading]="false"
    [animation]="{
    show: { type: 'fade', from: 0, to: 1, duration: 200  },
    hide: { type: 'fade', from: 1, to: 0, duration: 200 }
  }"
    position="top"
    [closeOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'title'" class="popover-title">
    <p class="title-text">Support/Resistance Levels</p>
  </div>
  <div class="popover-content"
       (mouseenter)="onPopoverMouseEnter()"
       (mouseleave)="onPopoverMouseLeave()">

    <!-- Loading indicator -->
    <div class="loading-container" *ngIf="loading">
      <dx-load-indicator
        [visible]="true"
        [height]="40"
        [width]="40">
      </dx-load-indicator>
    </div>

    <!-- Content -->
    <div *ngIf="!loading" class="levels-content">

      <!-- Type 1-->
      <ng-container *ngIf="this.currentZoneData?.type === 'Type 1'">

        <!-- Empty state -->
        <div class="empty-state" *ngIf="type1Levels.length === 0">
          <p>No support/resistance levels defined</p>
        </div>

        <!-- Levels table -->
        <dx-scroll-view>
          <div class="levels-table" *ngIf="type1Levels.length > 0">
            <!-- Table header -->
            <div class="table-header table-row">
              <div class="col col-sequence">&nbsp;</div>
              <div class="col col-price">Level</div>
              <div class="col col-type">Type</div>
            </div>

            <!-- Table body -->
            <div class="table-body type1">
              <div class="table-row"
                   [class.level-row]="level.type === 'level'"
                   [class.zone-row]="level.type === 'zone'"
                   *ngFor="let level of type1Levels; let i = index;"
              >
                <div *ngIf="level.type === 'level'" class="level" [ngClass]="getLevelClass(level.level)">
                  <div class="col col-sequence">&nbsp;</div>
                  <div class="col col-price">{{ formatPrice(level.level.price) }}</div>
                  <div class="col col-type">
                    <span class="type-badge"
                          [class.support]="this.getLevelLabel(level.level) === 'Support'"
                          [class.resistance]="this.getLevelLabel(level.level) === 'Resistance'"
                    >
                      {{ this.getLevelLabel(level.level) }}
                    </span>
                  </div>
                </div>

                <div *ngIf="level.type === 'zone'" class="zone-price"
                     [class.current]="this.isCurrentZone(level.zone)"
                >
                  {{ level.zone }}
                </div>
              </div>
            </div>
          </div>
        </dx-scroll-view>

      </ng-container>

      <!-- Type 2  -->
      <ng-container *ngIf="this.currentZoneData?.type === 'Type 2'">

        <!-- Empty state -->
        <div class="empty-state" *ngIf="type2Levels.length === 0">
          <p>No support/resistance levels defined</p>
        </div>

        <!-- Levels table -->
        <dx-scroll-view>
          <div class="levels-table" *ngIf="type2Levels.length > 0">
            <!-- Table header -->
            <div class="table-header table-row">
              <div class="col col-price">Level</div>
              <div class="col col-type">Type</div>
            </div>

            <!-- Table body -->
            <div class="table-body type2">
              <div class="table-row level-row"
                   [class.pickable]="this.canSetZone"
                   (dblclick)="this.setAsCurrentZone(row.level)"
                   *ngFor="let row of type2Levels; let i = index;"
              >
                <div class="level" [ngClass]="getLevelClass(row.level)">
                  <div class="col col-price">{{ formatPrice(row.level.price) }}</div>
                  <div class="col col-type">
                      <span class="type-badge"
                            [class.support]="this.getLevelLabel(row.level) === 'Support'"
                            [class.resistance]="this.getLevelLabel(row.level) === 'Resistance'"
                            [class.zone]="this.getLevelLabel(row.level) === 'Zone'"
                            [class.undefined]="this.getLevelLabel(row.level) === 'Undefined'"
                      >
                      {{ this.getLevelLabel(row.level) }}
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </dx-scroll-view>
      </ng-container>

      <!-- Type 3 (CR-20260913-001): the generated ladder, zone lines only. Its own block -
           nothing of Type 2 (owner ruling 2026-09-13). A super user may double-click a line to
           set it as the zone (owner ruling 2026-09-15); the ladder then recentres on it. -->
      <ng-container *ngIf="this.currentZoneData?.type === 'Type 3'">

        <div class="empty-state" *ngIf="type3Levels.length === 0">
          <p>No zone lines generated</p>
        </div>

        <dx-scroll-view>
          <div class="levels-table" *ngIf="type3Levels.length > 0">
            <div class="table-header table-row">
              <div class="col col-price">Level</div>
              <div class="col col-type">Type</div>
            </div>

            <div class="table-body type3">
              <div class="table-row level-row"
                   [class.pickable]="this.canSetZone"
                   (dblclick)="this.setAsCurrentZone3(line)"
                   *ngFor="let line of type3Levels; let i = index;"
              >
                <div class="level" [ngClass]="getType3LevelClass(line)">
                  <div class="col col-price">{{ formatPrice(line.price) }}</div>
                  <div class="col col-type">
                      <span class="type-badge"
                            [class.support]="this.getType3LevelLabel(line) === 'Support'"
                            [class.resistance]="this.getType3LevelLabel(line) === 'Resistance'"
                            [class.zone]="this.getType3LevelLabel(line) === 'Zone'"
                            [class.undefined]="this.getType3LevelLabel(line) === 'Undefined'"
                      >
                      {{ this.getType3LevelLabel(line) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </dx-scroll-view>
      </ng-container>
    </div>
  </div>
</dx-popover>

<ets-generic-confirmation-dialog
  #confirmationDialog
  title="Please Confirm"
></ets-generic-confirmation-dialog>